import React, { Component } from "react";
import Footer from "../../components/Footer/footer";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import Section from "./section";

class FuelOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navClass: "",
      imglight: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    const scrollup = document.documentElement.scrollTop;
    this.setState({ navClass: scrollup > 40 ? "nav-sticky" : "", imglight: false });
  };

  render() {
    return (
      <React.Fragment>
        <NavbarPage navClass={this.state.navClass} imglight={this.state.imglight} />
        <Section />
        <Footer />
      </React.Fragment>
    );
  }
}

export default FuelOrder;
